import { loan_application } from '@axo/shared/data-access/types';

export const debtIsFilled = (
  debt: Partial<loan_application.Debt> | undefined
) => {
  if (!debt) return true;

  if (debt?.Type === loan_application.DebtType.Collection) return true;

  if (debt?.Source) {
    if (!debt.Type) return false;
    if (debt.Type === loan_application.DebtType.Unspecified) return false;

    return true;
  }

  if (
    Object.entries(debt).some(([key, value]) => {
      if (key === 'RefinanceAmount') return false;
      if (value === null || value === 0 || value === '') {
        console.warn(`Error: Debt not fully filled: ${key} is ${value}`);
        return true;
      }

      return false;
    })
  ) {
    return false;
  }

  return true;
};
